"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = exports.action = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
const common_2 = require("../../../../common");
/** относительно `${config.http.webAuthUrl}` */
exports.action = 'set-password';
exports.path = 'set-password';
exports.method = common_1.HttpMethod.POST;
// #region Request
exports.BodySchema = zod_1.z.object({
  password: common_2.BasicPassword,
  password_confirm: common_2.BasicPassword
}).superRefine(({
  password_confirm,
  password
}, ctx) => {
  if (password_confirm !== password) {
    ctx.addIssue({
      code: "custom",
      message: "password_did_not_match",
      path: ['password_confirm']
    });
  }
});
function parseBody(dto) {
  return exports.BodySchema.parse(dto);
}
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  success: zod_1.z.string().optional()
});
function parseResponse(dto) {
  return exports.ResponseSchema.parse(dto);
}
// #endregion
